import { render, staticRenderFns } from "./GoogleFooter.vue?vue&type=template&id=12a1ac6a&"
import script from "./GoogleFooter.vue?vue&type=script&lang=js&"
export * from "./GoogleFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports